import React, { Dispatch, ReactNode, useCallback } from 'react';

import { IBaseProps } from '@rbi-ctg/frontend';
import { IStore } from '@rbi-ctg/store';
import { StoreCardSlim } from 'components/store-card-slim';
import { CustomEventNames, EventTypes, useMParticleContext } from 'state/mParticle';

import LoadingIndicator from './loading-indicator';
import { StoreCardsListContainer } from './styled/store-cards-list-container';

export interface IStoreCardsProps extends IBaseProps {
  activeStoreId?: string;
  setActiveStoreId: Dispatch<string>;
  nearbyStoreCardRefs?: object;
  noStoresElement: ReactNode;
  searching: boolean;
  stores?: IStore[];
  onClickRestaurantHoursInfo?: () => void;
}

export function StoreCards({
  searching,
  stores,
  nearbyStoreCardRefs,
  setActiveStoreId,
  noStoresElement,
  activeStoreId,
  onClickRestaurantHoursInfo,
}: IStoreCardsProps) {
  const mParticle = useMParticleContext();
  const handleStoreCardClick = useCallback(
    restaurantId => {
      if (restaurantId === activeStoreId) {
        return;
      }

      setActiveStoreId(restaurantId);
      mParticle.logEvent(CustomEventNames.BUTTON_CLICK, EventTypes.Other, {
        Name: 'Store card event',
        StoreID: restaurantId,
      });
    },
    [activeStoreId, mParticle, setActiveStoreId]
  );

  if (searching) {
    return <LoadingIndicator />;
  }

  if (stores?.length === 0) {
    return <>{noStoresElement}</>;
  }

  return (
    <StoreCardsListContainer data-testid="store-cards-list">
      {stores?.map(restaurant => (
        <StoreCardSlim
          innerRef={nearbyStoreCardRefs?.[restaurant._id]}
          restaurant={restaurant}
          isSelected={restaurant._id === activeStoreId}
          key={restaurant._id}
          onClick={() => handleStoreCardClick(restaurant._id)}
          onClickRestaurantHoursInfo={onClickRestaurantHoursInfo}
        />
      ))}
    </StoreCardsListContainer>
  );
}
